var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header',{attrs:{"headerType":2}}),_c('hr',{staticStyle:{"padding":"0px","margin":"0px"}}),_c('main',{staticClass:"page-with-sidebar"},[_c('menu-profile'),_vm._t("default")],2),_c('Footer',{attrs:{"footerType":2}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }